module Meevo.Plugins.ProductCategories {
  "use strict";

  /**
  * Main Section of ProductCategory 
  */
  export class MainSection extends Meevo.Components.BaseClasses.DataMaintenanceSectionBase<Model.ProductCategory> {

    /**
  * Base class override which defines what a DEFAULT model looks like.
  */
      createSectionModelInstance(postAdd:(data:any)=>any): void {
      //this.baseEndpoint
          this.dataService.getTemplate("ProductCategory").then((data) => {              
              this.model = data;
              this.model.locationOverride = { locations: [] };
          });
      }
  }

}